<template>
	<sky-select
		:size="size"
		:disabled="disabled"
		filterable
		remote
		clearable
		:props="props"
		@change="change"
		:options="options"
		v-model="user"
		v-bind="$attrs"
		:placeholder="placeholder"
		:remote-method="search"
	></sky-select>
</template>

<script>
import skySelect from '@/components/iglobalwin/formComponents/sky-select';
import { searchUser } from '@/backend/services/sso/sso';

export default {
	name: 'userSearch',
	components: {
		skySelect,
	},
	props: {
		value: {
			required: true,
		},
		size: {
			required: false,
		},
		disabled: {
			default: false,
		},
		onPosition: {
			default: '0',
		},
		placeholder: {
			default: '用户名称',
		},
	},
	data() {
		return {
			filterable: true,
			remote: true,

			options: [],
			props: {
				label: 'showName',
				value: 'id',
			},
			user: '',
		};
	},
	methods: {
		change(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		},
		search(val) {
			return searchUser({
				name: val,
				onPosition: this.onPosition,
			})
				.then(val => {
					this.options = val.data;
					return val.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
	},
	watch: {
		value: {
			handler(val) {
				if (val !== this.user) {
					this.search(val).then(() => {
						this.user = val;
					});
				}
			},
			immediate: true,
		},
	},
};
</script>

<style scoped></style>
